import React from 'react';
import { AlertCircle, X } from 'lucide-react';

const ErrorAlert = ({
  error,
  onClose,
  className = '',
  showIcon = true,
  variant = 'error'
}) => {
  if (!error) return null;

  const getVariantClasses = (variant) => {
    switch (variant) {
      case 'error': return { container: 'bg-red-50 border-red-200', icon: 'text-red-600', text: 'text-red-600' };
      case 'warning': return { container: 'bg-yellow-50 border-yellow-200', icon: 'text-yellow-600', text: 'text-yellow-600' };
      case 'info': return { container: 'bg-blue-50 border-blue-200', icon: 'text-blue-600', text: 'text-blue-600' };
      case 'success': return { container: 'bg-green-50 border-green-200', icon: 'text-green-600', text: 'text-green-600' };
      default: return { container: 'bg-red-50 border-red-200', icon: 'text-red-600', text: 'text-red-600' };
    }
  };

  const classes = getVariantClasses(variant);

  return (
    <div className={`border rounded-lg p-3 ${classes.container} ${className}`}>
      <div className="flex items-start justify-between">
        <div className="flex items-start space-x-2">
          {showIcon && (
            <AlertCircle className={`w-5 h-5 ${classes.icon} mt-0.5 flex-shrink-0`} />
          )}
          <p className={`text-sm ${classes.text}`}>
            {typeof error === 'string' ? error : error.message || 'An error occurred'}
          </p>
        </div>
        {onClose && (
          <button onClick={onClose} className={`ml-2 hover:opacity-70 ${classes.icon}`}>
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorAlert;
